import { Box, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { FaHome, FaChargingStation, FaSolarPanel,  FaNetworkWired, FaHandsHelping,  FaWrench, FaPhone, FaLightbulb, FaTachometerAlt, FaProjectDiagram, FaMicrochip } from 'react-icons/fa';
import ServiceCard from "./ServiceCard";
import { useInView } from "react-intersection-observer";
import CameraOutdoorIcon from "@mui/icons-material/CameraOutdoor";


function Services() {
  const [activeIndex, setActiveIndex] = useState(null);

  const { ref: titleRef, inView: titleInView } = useInView({
    triggerOnce: false,
    threshold: 0.2,
  });

  const { ref: gridRef, inView: gridInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

 
  
  const services = [
      {
        icon: <FaChargingStation />,
        title: "Wallbox",
        src: "Card1.jpg",
        description: "Ladestation für Elektrofahrzeuge, die Ihre Mobilität zu Hause oder im Büro ermöglicht.",
      },
      {
        icon: <FaSolarPanel />,
        title: "Photovoltaikanlagen",
        src: "Photovoltaikanlagen.jpeg",
        description: "Installation und Wartung von Solaranlagen, um erneuerbare Energie zu nutzen.",
      },
      {
        icon: <FaWrench />,
        title: "Prüfung Wartung",
        src: "PrüfungWartung.jpg",
        description: "Regelmäßige Inspektionen und Wartungsservices für alle Elektrotechniksysteme.",
      },
      {
        icon: <FaHome />,
        title: "Smart Home",
        src: "SmartHome.jpg",
        description: "Automatisierte Lösungen für Ihr Zuhause, um Komfort und Sicherheit zu erhöhen.",
      },
      {
        icon: <FaPhone />,
        title: "Sprechanlage",
        src: "Sprechanlage.jpg",

        description: "Moderne Sprechanlagen zur Kommunikation innerhalb von Gebäuden.",
      },
      {
        icon: <CameraOutdoorIcon style={{ fontSize: '2rem', color: 'black' }} />,
        title: "Überwachungskamera",
        src: "Überwachungskamera.jpg",
        description: "Überwachungskameras zur Sicherheit von Zuhause und Geschäftseinrichtungen.",
      },
      {
        icon: <FaNetworkWired />,
        title: "Netzwerktechnik",
        src: "Netzwerktechnik.jpg",

        description: "Einrichtung und Wartung von Netzwerksystemen für effiziente Kommunikation und Datenübertragung.",
      },
      {
        icon: <FaHandsHelping />,
        title: "Kundendienst",
        src: "Kundendienst.jpg",

        description: "Professionelle Unterstützung und Reparaturdienste für alle Ihre Elektrotechnikbedürfnisse.",
      },
      {
        icon: <FaLightbulb />,
        title: "Beleuchtung",
        src: "Beleuchtung.jpg",

        description: "Innovative Lichtlösungen für Innen- und Außenbereiche.",
      },
      {
        icon: <FaTachometerAlt />,
        title: "Messung",
        src: "Messung.png",
        description: "Präzise Messsysteme zur Überwachung elektrischer Parameter.",
      },
      {
        icon: <FaProjectDiagram />,
        title: "KNX",
        src: "KNX.jpg",

        description: "Intelligente Gebäudesteuerung mit KNX für mehr Komfort und Effizienz.",
      },
      {
        icon: <FaMicrochip />,
        title: "Siemens Logo",
        src: "Siemens.png",

        description: "Programmierbare Steuerungen für smarte Automatisierungslösungen.",
      },
  ];
  
  
  
  
  

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center" id="services" sx={{  zIndex: 999 }}>
         <Box
    sx={{
      backgroundImage: {
      xs:`url(/Phone2.png)`,
      md:`url(/tt.png)`,
      },
      marginTop:'20px',
      backgroundAttachment:'fixed',
      backgroundPosition:'center',
      backgroundOrigin:"content-box",
      backgroundPositionY:'center',
      backgroundSize: {
        xs:'contain',
        md:'contain'
      }, 
        width: '100%',  
        height:{
          xs:'20vh',
          md:'30vh'
        }


    }}
    >
   

    </Box>
      <Grid item xs={12}
      sx={{
        background: "linear-gradient(to right, #ece9e6, #ffffff)",

      }}
      >
        <Box
          ref={titleRef}
          sx={{
            padding: { xs: "2rem 1rem", sm: "3rem 2rem", md: "4rem 3rem" },
            borderRadius: "16px",
            textAlign: "center",
            maxWidth: "900px",
            margin: "0 auto",
            marginTop: "2rem",
            
            opacity: titleInView ? 1 : 0,
            transform: titleInView ? "translateY(0)" : "translateY(50px)",
            transition: "opacity 0.8s ease, transform 0.8s ease",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              letterSpacing: "1px",
              fontWeight: "bold",
              color: "#333",
              textTransform: "uppercase",
              marginBottom: 2,
              fontFamily: "Roboto Slab, serif",
            }}
          >
            Unsere Dienstleistungen
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginTop: 2,
              color: "#333",
              lineHeight: 1.8,
              fontSize: { xs: "1rem", sm: "1.2rem" },
              textShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            Neben der fachgerechten Installation von Solaranlagen und Elektroinstallation bieten wir umfassende Leistungen in der Netzwerktechnik an. Ob Sie Ihr Zuhause in ein Smart Home verwandeln wollen oder eine effiziente Wallbox für Ihr Elektroauto benötigen, unser Team aus geschulten Fachkräften steht bereit. Wir streben danach, Ihre Anforderungen nicht nur zu erfüllen, sondern zu übertreffen, indem wir langlebige und effiziente Lösungen anbieten.
          </Typography>
        </Box>
      </Grid>
   

      <Grid item xs={12}>
        <Grid
          container
          padding={5}
          spacing={5}
          ref={gridRef}
          sx={{
            opacity: gridInView ? 1 : 0,
            transform: gridInView ? "translateY(0)" : "translateY(50px)",
            transition: "opacity 0.8s ease, transform 0.8s ease",
          }}
        >
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
              <ServiceCard
                service={service}
                index={index}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Services;
